export enum ActionButtonVariant {
  Default = "default",
  Move = "move",
  Cancel = "cancel",
  Change = "change",
}
